import {
  FETCH_FEEDBACK_REPORT_DATA_START,
  FETCH_FEEDBACK_REPORT_DATA_SUCCESS,
  FETCH_FEEDBACK_REPORT_DATA_FAILED
} from '../actionTypes'

import { getListingIndex } from '../../../helpers/utils'
import { enqueueSnackbar } from '../alert'
import baseAxios from '../../../axios/base'

export const fetchFeedbackReportData = filterOptions => {
  return async dispatch => {
    dispatch(fetchFeedbackReportDataStart())
    try {
      const response = await baseAxios.get('/feedback/report', {
        params: filterOptions
      })

      if (response.status === 200) {
        const { current_page, from, last_page, per_page, to, total, data } = response.data.data

        const pagination = {
          currentPage: current_page,
          lastPage: last_page,
          perPage: +per_page,
          from,
          to,
          total
        }

        const dataWithIndex = data.map((item, index) => {
          return { ...item, index: getListingIndex(index, per_page, current_page) }
        })

        dispatch(fetchFeedbackReportDataSuccess(pagination, dataWithIndex, filterOptions))
      }
    } catch (error) {
      dispatch(fetchFeedbackReportDataFailed(error))
      dispatch(
        enqueueSnackbar({
          message: 'Feedback Report Data Error',
          options: {
            variant: 'error'
          }
        })
      )
    }
  }
}

const fetchFeedbackReportDataStart = () => {
  return {
    type: FETCH_FEEDBACK_REPORT_DATA_START
  }
}

const fetchFeedbackReportDataSuccess = (pagination, records, filter) => {
  return {
    type: FETCH_FEEDBACK_REPORT_DATA_SUCCESS,
    pagination,
    records,
    filter
  }
}

const fetchFeedbackReportDataFailed = errorMessage => {
  return {
    type: FETCH_FEEDBACK_REPORT_DATA_FAILED,
    errorMessage
  }
}
